/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Comms from './Comms/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Footer from './Footer/index'
import Header from './Header/index'
import Letter from './Letter/index'
import React from 'react'
import TasksViewForm from 'DesignSystem/TasksViewForm/index'
import TysiaOverlay from 'DesignSystem/TysiaOverlay/index'
import TysiaOverlayContent from 'DesignSystem/TysiaOverlay/TysiaOverlayContent/index'
import TysiaOverlayFooter from 'DesignSystem/TysiaOverlay/TysiaOverlayFooter/index'
import TysiaOverlayHeader from 'DesignSystem/TysiaOverlay/TysiaOverlayHeader/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/TaskOverlay/Content/Content"
  
}) {
let taskBoardIdValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'board_id',
})
let tabSelectedTaskOverlayTaskIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.task_overlay.task_id',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let tabSelectedTaskOverlayTaskIdValueData1 = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.task_overlay.task_id',
})
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
 data="task.board_id"
 boardId={taskBoardIdValueData}
 data="tab.selected.task_overlay.task_id"
 taskId={tabSelectedTaskOverlayTaskIdValueData}
/>
<TysiaOverlay
  viewPath={`${viewPath}/TysiaOverlay`}
 left="auto"
 right={dtSpaceS}
 width="500px"
>
{childProps => (
<React.Fragment>
<TysiaOverlayHeader
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayHeader`}
>
{childProps => (
<Header
{...childProps}
  viewPath={`${viewPath}/Header`}
/>
)}
</TysiaOverlayHeader>
<TysiaOverlayContent
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayContent`}
>
{childProps => (
<TasksViewForm
{...childProps}
  viewPath={`${viewPath}/TasksViewForm`}
 data="tab.selected.task_overlay.task_id"
 task_id={tabSelectedTaskOverlayTaskIdValueData1}
/>
)}
</TysiaOverlayContent>
<TysiaOverlayFooter
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayFooter`}
>
{childProps => (
<Footer
{...childProps}
  viewPath={`${viewPath}/Footer`}
/>
)}
</TysiaOverlayFooter>
</React.Fragment>
)}
</TysiaOverlay>
<Letter
  viewPath={`${viewPath}/Letter`}
/>
<Comms
  viewPath={`${viewPath}/Comms`}
/>
{children}
</React.Fragment>)
}